import {
  URL_FUNCION,
  URL_ACTUALIZAR_FUNCIONES,
  URL_OBTENER_PERFILES,
  URL_IMPORTAR_PERFIL,
} from "../Utils/constant.js";
import { useBuscarHelper } from "../../../Commons/Scripts/Utils/webservice-helper.js";

export const useBuscarFunciones = (where) => {
  const url = URL_FUNCION;
  const { data, loading, error } = useBuscarHelper(url, where);
  return {
    data,
    loading,
    error,
  };
};

export const actualizarFunciones = (where) => {
  const url = URL_ACTUALIZAR_FUNCIONES;
  return new Promise((resolve, reject) => {
    Citrus.AJAX.getJSON(url, where, function (respuesta) {
      const datos = $.parseJSON(respuesta.d);
      if (
        datos &&
        datos["Mensaje"] !== undefined &&
        datos["Detalle"] !== undefined &&
        datos["Interno"] !== undefined
      ) {
        reject(datos);
      }
      resolve(datos);
    });
  });
};

export const obtenerPerfilesAImportar = (where) => {
  const url = URL_OBTENER_PERFILES;
  return new Promise((resolve, reject) => {
    Citrus.AJAX.getJSON(url, where, function (respuesta) {
      const datos = $.parseJSON(respuesta.d);
      if (
        datos &&
        datos["Mensaje"] !== undefined &&
        datos["Detalle"] !== undefined &&
        datos["Interno"] !== undefined
      ) {
        reject(datos);
      }
      resolve(datos);
    });
  });
};

export const importarPerfil = (where) => {
  const url = URL_IMPORTAR_PERFIL;
  return new Promise((resolve, reject) => {
    Citrus.AJAX.getJSON(url, where, function (respuesta) {
      const datos = $.parseJSON(respuesta.d);
      if (
        datos &&
        datos["Mensaje"] !== undefined &&
        datos["Detalle"] !== undefined &&
        datos["Interno"] !== undefined
      ) {
        reject(datos);
      }
      resolve(datos);
    });
  });
};
